import { mapGetters, mapActions } from 'vuex';
import {
  getUserPlaylistStorageName,
  getUserPlaylistSortStorageName,
  setToLocalStorage,
  getFromStorage,
} from '@/utils';
import { getProgramList } from '@/services/program';

const PlayerPlaylistStorageMixin = {
  computed: {
    ...mapGetters([
      'player',
      'globalPlaylist',
    ]),
  },
  methods: {
    ...mapActions([
      'toggleGlobalPlayList',
    ]),
    /**
     * 序列化播放列表
     * @param list
     * @returns {string}
     */
    stringifyPlaylist(list) {
      return JSON.stringify(list);
    },

    /**
     * 解析播放列表
     * @param list
     * @returns {any}
     */
    parsePlaylist(list) {
      return JSON.parse(list);
    },

    /**
     * 将播放列表设于本地缓存
     * @param list
     */
    setGlobalPlaylistStorage(list) {
      const name = getUserPlaylistStorageName();
      setToLocalStorage(name, this.stringifyPlaylist(list));
    },

    /**
     * 设置播放列表于vuex
     * @param list
     */
    setGlobalPlaylistVuex(list) {
      this.toggleGlobalPlayList(list);
    },

    /**
     * 从本地缓存中获取播放列表
     * @returns {*|any}
     */
    getGlobalPlaylistStorage() {
      const name = getUserPlaylistStorageName();
      const list = getFromStorage(name);
      return this.parsePlaylist(list);
    },

    /**
     * 向后端获取音频Program 列表
     * @param id
     * @param start
     * @param limit
     * @param sort
     * @param type
     * @returns {Promise<any>}
     */
    getProgramListData(id, start, limit, sort = 'asc', type = 'program') {
      return new Promise(async (resolve, reject) => {
        // 处理通过音频ID 或 通过ProgramID 获取大纲列表
        const obj = type === 'audio' ? { id } : { programId: id };
        const params = Object.assign({
          start,
          sort,
          limit,
        }, obj);
        try {
          const data = await getProgramList(params, true);
          return resolve(data.list);
        } catch (e) {
          return reject(e);
        }
      });
    },

    /**
     * 获取真实播放列表
     * @param id
     * @param sort
     * @param type
     * @returns {*}
     */
    fetchRealPlaylist(id, sort, type) {
      const { globalPlaylist, $route } = this;
      const blackListName = ['AudioProgramDetail', 'VideoProgramDetail'];
      const blacklist = blackListName.indexOf($route.name) > -1;
      const getPlaylistByVuex = (globalPlaylist.length !== 0) && blacklist;
      if (getPlaylistByVuex) return this.globalPlaylist;
      return this.getProgramListData(id, 0, 10000, sort, type);
    },

    /**
     * 生成全局播放列表
     * @param list
     * @param autoAudio
     * @param logType
     */
    generateGlobalPlayerPlaylist(list, autoAudio = true, logType = 'program') {
      return list.map((item) => {
        item.playerMediaType = autoAudio ? 'audio' : item.mediaType;
        item.type = logType;
        return item;
      });
    },

    /**
     * 设置全局播放器信息
     * @param list
     * @param autoAudio
     * @param setVuex
     * @param logType
     */
    setGlobalPlayerInfo(list, autoAudio = true, setVuex = false, logType) {
      const playlist = this.generateGlobalPlayerPlaylist(list, autoAudio, logType);
      this.player.updatePlaylist(playlist);
      this.setGlobalPlaylistStorage(playlist);
      if (setVuex) {
        this.setGlobalPlaylistVuex(playlist);
      }
    },

    /**
     * 从本地缓存获取全局播放器排序方式
     * @returns {*|string}
     */
    getGlobalPlayerSort() {
      const name = getUserPlaylistSortStorageName();
      return getFromStorage(name) || 'asc';
    },

    /**
     * 设置全局播放器排序方式至本地缓存
     * @param sort
     * @returns {*}
     */
    setGlobalPlayerSort(sort) {
      const name = getUserPlaylistSortStorageName();
      return setToLocalStorage(name, sort);
    },

    /**
     * 处理全局播放列表排序
     * @param sort
     */
    handleGlobalSwitchSort(sort) {
      const oldPlaylist = this.getGlobalPlaylistStorage();
      const newPlaylist = oldPlaylist.reverse();

      this.setGlobalPlaylistStorage(newPlaylist);
      if (this.globalPlaylist.length !== 0) {
        this.setGlobalPlaylistVuex(newPlaylist);
      }
      this.setGlobalPlayerSort(sort);
    },
  },
};

export default PlayerPlaylistStorageMixin;
